export const STATUSCHANGED = "status/changed";
export const COLORCHANGED = "status/colorchanged";